class Navbar2Controller {
  constructor(authService, $state, $interval, $ngConfirm, growl, appConfig) {
    "ngInject";

    this.authService = authService;
    this.$state = $state;
    this.$ngConfirm = $ngConfirm;
    this.growl = growl;
    this.appConfig = appConfig;

    this.sessionTimer = "";

    this.timerFn = $interval(this.updateSessionTimer.bind(this), 1000);

    this.logoutWarningThreshold = 10;
    this.warningDialog = null;
    this.logoutDialog = null;
  }

  updateLocation(loc) {
    if (loc.key !== this.authService.authData.currentLocation.key){
      const sure = window.confirm('Are you sure you want to change your current location');

      if (sure){
        this.authService.authData.currentLocation = loc;
        this.authService.getLocationExtendedProperties('dashboardPreferences');
        this.$state.transitionTo('welcomeCentre', null, {
          reload: true, inherit: false
        });
      }
    }
  }

  updateSessionTimer() {
    if (!this.authService.isLoggedIn_NoRedirect()){
      return;
    }

    const remainingMs = this.authService.timeToLogout();
    const remainingPercent = Math.floor((remainingMs / this.authService.authData.expiryMs) * 100);

    //if logout warning threshold reached
    if (remainingPercent <= this.logoutWarningThreshold){
      this.showWarningDialog();
    }

    if (remainingPercent <= 1){
      this.showLoggedOutDialog();
    }

    if (remainingMs && remainingMs > 0){
      this.sessionTimer = this.msToTime(remainingMs);
    }
    else {
      this.sessionTimer = null;
    }
  }

  msToTime(s) {
    // Pad to 2 or 3 digits, default is 2
    var pad = (n, z = 2) => ('00' + n).slice(-z);
    return pad(s/3.6e6|0) + ':' + pad((s%3.6e6)/6e4 | 0) + ':' + pad((s%6e4)/1000|0);
  }

  showWarningDialog(){    
    if (this.warningDialog){
      return;
    }

    this.warningDialog = this.$ngConfirm({
      title: "Warning",
      content: `Your session will expire soon`,
      type: 'orange',
      columnClass: 'l',
      buttons: {
        renew: {
          text: 'Renew',
          btnClass: 'btn-primary',
          action: () => {
            this.renew();

          }
        },
        cancel: {
          text: 'Leave it',
          btnClass: 'btn-default',
          action: () => {}
        }
      }
    });
  }

  showLoggedOutDialog() {
    if (this.logoutDialog){
      return;
    }

    this.warningDialog.close();

    this.logoutDialog = this.$ngConfirm({
      title: "Error",
      content: `Your session has expired`,
      type: 'red',
      columnClass: 'l',
      buttons: {
        ok: {
          text: 'Ok',
          btnClass: 'btn-default',
          action: () => {
            this.authService.logOut();
          }
        }
      }
    });    
  }

  renew(){
    this.authService.renewSession()
      .then(() => {
        this.growl.success('Session renewed successfully', {ttl: 5000});

        this.warningDialog = null;
        this.logoutDialog = null;
      });
  }

}

export default Navbar2Controller;



// WEBPACK FOOTER //
// ./client/app/common/navbar2/navbar2.controller.js